<template>
  <div class="relative">
    <input
      type="text"
      v-model="localValue"
      class="w-full px-4 py-2 border border-gray-200 rounded-lg text-gray-800 focus:outline-none focus:border-gray-300 focus:ring-0 transition-colors font-handwriting text-3xl"
      :placeholder="!isFocused ? placeholder : ''"
      @focus="isFocused = true"
      @blur="handleBlur"
      @input="$emit('update:modelValue', localValue)"
    />
  </div>
</template>

<script>
export default {
  name: "PortalBillingProposalTermsInput",
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "Type your name here...",
    },
  },
  emits: ["update:modelValue", "blur"],

  data() {
    return {
      localValue: this.modelValue,
      isFocused: false,
    }
  },

  watch: {
    modelValue(newVal) {
      this.localValue = newVal
    },
    localValue(newVal) {
      this.$emit("update:modelValue", newVal)
    },
  },

  methods: {
    handleBlur() {
      this.isFocused = false
      // Only emit if there's actually a value
      if (this.localValue) {
        this.$emit("blur")
      }
    },
  },
}
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Caveat:wght@400;500&display=swap");

.font-handwriting {
  font-family: "Caveat", cursive;
}
</style>
